import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_5 = { class: "svg-icon svg-icon-1 position-absolute ms-4" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "card-toolbar" }
const _hoisted_8 = {
  key: 0,
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_9 = {
  type: "button",
  class: "btn btn-light-primary me-3",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end"
}
const _hoisted_10 = { class: "svg-icon svg-icon-2" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 0,
  class: "svg-icon svg-icon-2"
}
const _hoisted_13 = {
  key: 1,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_14 = { class: "card-body pt-0" }
const _hoisted_15 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_FilterDropdown = _resolveComponent("FilterDropdown")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MBDatatable = _resolveComponent("MBDatatable")!
  const _directive_auth = _resolveDirective("auth")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen021.svg" })
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchItems())),
            class: "form-control form-control-solid w-250px ps-14",
            placeholder: _ctx.t('common.search')
          }, null, 40, _hoisted_6), [
            [_vModelText, _ctx.search]
          ]),
          _withDirectives(_createElementVNode("span", {
            class: "svg-icon svg-icon-1 position-absolute top-50 end-0 mr-2 translate-middle",
            style: {"cursor":"pointer"},
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.removeSearch && _ctx.removeSearch(...args)))
          }, [
            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
          ], 512), [
            [_vShow, _ctx.search != '']
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.checkedImportDeclaration.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("button", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen031.svg" })
                ]),
                _createTextVNode(_toDisplayString(_ctx.t("common.filter")), 1)
              ]),
              _createVNode(_component_FilterDropdown, {
                onSubmitFilter: _ctx.handleFilter,
                onResetFilter: _ctx.handleFilterReset
              }, null, 8, ["onSubmitFilter", "onResetFilter"]),
              _withDirectives((_openBlock(), _createElementBlock("button", {
                type: "button",
                class: "btn btn-light-primary",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.fileExportReport && _ctx.fileExportReport(...args))),
                disabled: _ctx.disabledExportReport
              }, [
                (!_ctx.disabledExportReport || (_ctx.loading && _ctx.disabledExportReport))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr091.svg" })
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_13)),
                _createTextVNode(" " + _toDisplayString(_ctx.t("common.export")), 1)
              ], 8, _hoisted_11)), [
                [_directive_auth, { auth: ['export'] }]
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_MBDatatable, {
        loading: _ctx.loading,
        "table-data": _ctx.tableData,
        "table-header": _ctx.tableHeader,
        "enable-items-per-page-dropdown": true,
        "current-page": _ctx.currentPage,
        total: _ctx.total,
        "rows-per-page": _ctx.pageSize,
        onCurrentChange: _ctx.onCurrentPageChange,
        onItemsPerPageChange: _ctx.onRowsPerPageChange,
        onSort: _ctx.onColumnSort
      }, {
        "cell-declaration_date": _withCtx(({ row: item }) => [
          _createTextVNode(_toDisplayString(_ctx.formatDate(item.declaration_date)), 1)
        ]),
        "cell-approval_date": _withCtx(({ row: item }) => [
          _createTextVNode(_toDisplayString(_ctx.formatDate(item.approval_date)), 1)
        ]),
        "cell-customs_inspection": _withCtx(({ row: item }) => [
          _createTextVNode(_toDisplayString(item.customs_inspection == 1 ? _ctx.t("common.yes") : _ctx.t("common.no")), 1)
        ]),
        "cell-export_port": _withCtx(({ row: item }) => [
          _createTextVNode(_toDisplayString(item.__show?.export_port), 1)
        ]),
        "cell-declaration_export_no": _withCtx(({ row: item }) => [
          _createVNode(_component_router_link, {
            to: 
              '/declaration-management/export-declaration/' + item.id + '/edit'
            ,
            class: "text-gray-800 text-hover-primary mb-1"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.declaration_export_no), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ]),
        "cell-tracking_no": _withCtx(({ row: item }) => [
          _createTextVNode(_toDisplayString(item.tracking_no), 1)
        ]),
        "cell-short_code": _withCtx(({ row: item }) => [
          _createTextVNode(_toDisplayString(item.short_code), 1)
        ]),
        "cell-export_handling_company": _withCtx(({ row: item }) => [
          _createTextVNode(_toDisplayString(item.__show?.export_handling_company), 1)
        ]),
        "cell-carrier_name": _withCtx(({ row: item }) => [
          _createTextVNode(_toDisplayString(item.carrier_name), 1)
        ]),
        "cell-awb_number": _withCtx(({ row: item }) => [
          _createTextVNode(_toDisplayString(item.awb_number), 1)
        ]),
        "cell-mrn_number": _withCtx(({ row: item }) => [
          _createTextVNode(_toDisplayString(item.mrn_number), 1)
        ]),
        "cell-status": _withCtx(({ row: item }) => [
          _createElementVNode("span", {
            class: _normalizeClass(["badge text-uppercase", _ctx.statusClass(item.status).statusClass])
          }, _toDisplayString(_ctx.statusClass(item.status).str), 3)
        ]),
        "cell-actions": _withCtx(({ row: item }) => [
          _createVNode(_component_router_link, {
            to: 
              '/declaration-management/export-declaration/' + item.id + '/edit'
            ,
            class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_15, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
              ])
            ]),
            _: 2
          }, 1032, ["to"])
        ]),
        _: 1
      }, 8, ["loading", "table-data", "table-header", "current-page", "total", "rows-per-page", "onCurrentChange", "onItemsPerPageChange", "onSort"])
    ])
  ]))
}